import React from 'react';

import MobilePageSkeleton from '../../components/skeleton/MobilePageSkeleton';
import PageSkeleton from '../../components/skeleton/PageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const PRODUCT_PAGE_CHUNK_NAME = 'productPage';

export const ProductPage = createRouteLoadable(
  () => import(/* webpackChunkName: "productPage" */ '../../pages/ProductPage'),
  {
    fallback: <PageSkeleton />,
  }
);

export const MobileProductPage = createRouteLoadable(
  () => import(/* webpackChunkName: "productPage" */ '../../pages/ProductPage'),
  {
    fallback: <MobilePageSkeleton />,
  }
);
